import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import AppAds from './AppAds';
import { restrictUrls } from '../../../helpers/adminPrivileges';

const title = 'Publicidad (App Ads)';

export default async function action({ store }) {
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if (!restrictUrls('/siteadmin/settings/site', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <AppAds title={title} />
            </AdminLayout>
        ),
    };
}
